import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { SharedModule } from './../shared/shared.module';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { TokenFormComponent } from './components/token-form/token-form.component';
import { LayoutModule } from '../layout/layout.module';

const LoginComponents = [
  { name: 'Login', type: LoginComponent },
  { name: 'Landing', type: LandingComponent },
  { name: 'TokenForm', type: TokenFormComponent }
];

@NgModule({
  declarations: [LoginComponent, LandingComponent, TokenFormComponent],
  exports: [LoginComponent],
  imports: [
    SharedModule,
    CommonModule,
    LayoutModule,
    JssModule,
    ReactiveFormsModule
  ]
})
export class LoginModule {}

export { LoginComponents };
